import React from 'react';

export default function Publications({ publications, pubError }) {
  return (
    <section id="publications" className="section publications-section">
      <h2>Publications</h2>
      {pubError || publications.length === 0 ? (
        <div className="publication-error">
          <p>
            Unable to fetch publications automatically. View my full publication list on{' '}
            <a href="https://scholar.google.com/citations?user=QcDFDqMAAAAJ" target="_blank" rel="noopener noreferrer">
              Google Scholar
            </a>
            .
          </p>
        </div>
      ) : (
        <div className="publications">
          {publications
            .sort((a, b) => (b.publication_year || 0) - (a.publication_year || 0))
            .map((pubItem) => (
            <div className="publication" key={pubItem.id}>
              <h3>
                <a
                  href={
                    pubItem.primary_location && pubItem.primary_location.landing_page_url
                      ? pubItem.primary_location.landing_page_url
                      : pubItem.doi || '#'
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {pubItem.display_name}
                </a>
              </h3>
              {pubItem.publication_year && (
                <p className="publication-year">{pubItem.publication_year}</p>
              )}
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
